/**
 * Frontend mirror of backend `defaultAudienceTierForType`
 * (`apps/backend/src/populations/utils/audience-tier.ts`).
 *
 * Keep in sync. B2B and B2C are labels; every new audience is Premium (`tier2`).
 */
export type CanonicalAudienceTier = 'tier1' | 'tier2' | 'tier3';
export type AudienceTypeForTier = 'B2B' | 'B2C';

export function defaultAudienceTierForType(
  _audienceType: AudienceTypeForTier | null | undefined,
): CanonicalAudienceTier {
  return 'tier2';
}
